export class Card {
    value: number
    id: number
    show: boolean = false

    constructor(value: number=0, id: number=0) {
        this.value = value
        this.id = id
    }
}
